// The booking wizard's wording in Haitian Creole; keys match en.ts. Machine-drafted, flagged for native review.
import type { en } from "./en";

export const ht = {
  // Page
  schedule_appointment: "Pran randevou",
  powered_by: "Pwopilse pa",

  // Patient type
  new_or_existing: "Èske ou se yon nouvo pasyan oswa yon pasyan ki deja la?",
  new_patient: "Nouvo pasyan",
  existing_patient: "Pasyan ki deja la",
  first_time_visiting: "Premye fwa m ap vizite klinik sa a",
  been_here_before: "Mwen te deja vini isit la",

  // Appointment info
  what_type: "Ki kalite randevou?",
  no_types_available: "Pa gen kalite randevou ki disponib pou pran sou entènèt kounye a.",
  minutes: "%{count} minit",
  additional_info: "Ki pwoblèm oswa enkyetid ou ta renmen nou wè?",
  describe_concern: "Tanpri dekri pwoblèm ou an...",

  // Provider
  pick_provider: "Chwazi yon doktè",
  loading_providers: "N ap chaje doktè yo...",
  failed_load_providers: "Nou pa t ka chaje doktè yo. Tanpri eseye ankò.",
  any_provider: "Nenpòt doktè",
  show_all_available: "Montre tout lè ki disponib",
  no_availability: "Pa gen disponibilite",

  // Time
  pick_a_time: "Chwazi yon lè",
  finding_times: "N ap chèche lè ki disponib...",
  no_times_for_date: "Pa gen lè disponib pou dat sa a",
  slot_just_taken: "Padon, yon lòt moun fèk pran lè sa a. Tanpri chwazi yon lòt.",
  jump_to_next: "Ale nan pwochen lè disponib",
  morning: "Maten",
  afternoon: "Apremidi",
  cant_find_time: "Ou pa jwenn yon lè? Rele klinik nou an epi n ap ede w jwenn youn.",

  // Patient info
  your_information: "Enfòmasyon ou",
  first_name: "Prenon",
  last_name: "Siyati",
  preferred_name: "Non ou pito",
  optional: "Opsyonèl",
  date_of_birth: "Dat nesans",
  phone_number: "Nimewo telefòn",
  required: "Obligatwa",
  invalid_phone: "Antre yon nimewo telefòn valid ki gen 10 chif",
  min_age: "Pasyan an dwe gen omwen 5 an",
  future_date: "Pa ka nan lavni",
  referral_question: "Kijan ou te tande pale de nou?",
  referral_prompt: "Chwazi yon opsyon",
  referral_detail_who: "Ki moun ki te refere w?",
  referral_detail_other: "Tanpri di nou kijan ou te tande pale de nou",
  referral_detail_optional: "Lòt detay (opsyonèl)",
  verification_disclaimer: "N ap voye yon kòd verifikasyon nan nimewo sa a.",
  phone_verified: "Telefòn verifye",
  verifying: "N ap verifye...",
  verify: "Verifye",
  invalid_code: "Kòd la pa valid. Tanpri eseye ankò.",
  sending: "N ap voye...",
  resend_code: "Voye kòd la ankò",
  email: "Imèl",
  send_verification: "Voye kòd verifikasyon",
  sending_code: "N ap voye kòd la...",

  // Insurance
  insurance_info: "Enfòmasyon asirans",
  have_insurance: "Èske ou gen asirans?",
  insurance_changed: "Èske asirans ou chanje depi dènye vizit ou?",
  no_insurance_change: "Pa gen chanjman",
  yes: "Wi",
  no: "Non",
  insurance_name: "Non asirans lan",
  subscriber_name: "Non abòne a",
  subscriber_dob: "Dat nesans abòne a",
  subscriber_id: "Nimewo abòne a",
  group_number: "Nimewo gwoup",
  select_option: "Tanpri chwazi yon opsyon",
  card_photo_title: "Foto kat asirans ou",
  card_photo_hint: "Ajoute foto tou de bò kat ou a pou nou ka verifye kouvèti ou anvan vizit ou.",
  card_front: "Devan kat la",
  card_back: "Dèyè kat la",
  add_photo: "Ajoute foto",
  uploading_photo: "N ap telechaje foto a...",
  remove_photo: "Retire",
  card_upload_failed: "Nou pa t ka ajoute foto a. Ou ka eseye ankò oswa kontinye san li.",
  card_try_again: "Eseye ankò",

  // Review
  review_appointment: "Revize randevou ou",
  appointment_details: "Detay randevou a",
  type_label: "Kalite",
  provider: "Doktè",
  any_available: "Nenpòt ki disponib",
  date_and_time: "Dat ak lè",
  notes: "Nòt",
  patient_information: "Enfòmasyon pasyan",
  name: "Non",
  phone: "Telefòn",
  insurance: "Asirans",
  subscriber: "Abòne",
  subscriber_id_label: "Nimewo abòne",
  group_hash: "Nimewo gwoup",
  no_insurance: "Pa gen asirans",
  card_photos: "Foto kat la",
  card_front_short: "Devan",
  card_back_short: "Dèyè",
  waitlist: "Kontakte m si gen lè ki vin disponib pi bonè",
  consent_prefix: "Lè ou pran randevou, ou dakò ak ",
  terms: "Tèm ak kondisyon",
  consent_and: " ak ",
  privacy: "Politik konfidansyalite",
  consent_suffix:
    " nou yo. Lè ou bay nimewo telefòn ou, ou dakò resevwa mesaj tèks. Frè mesaj ak done ka aplike.",
  scheduling: "N ap pran randevou a...",
  schedule_appointment_btn: "Pran randevou",
  continue_to_payment: "Kontinye pou peman",

  // Deposit
  deposit_title: "Peye depo ou",
  deposit_explainer:
    "Yon depo %{amount} konfime randevou sa a. L ap kredite sou kont ou epi aplike pou vizit ou. Si ou pa vini nan randevou ou, w ap pèdi depo ou.",
  deposit_due: "Depo",
  deposit_card_fee: "Frè kat",
  deposit_card_fee_notice:
    "Peman ak kat kredi gen yon frè tretman %{percentage}%. Pa gen frè pou kat debi.",
  deposit_total: "Total",
  deposit_loading: "N ap chaje peman sekirize a...",
  deposit_paying: "N ap trete...",
  deposit_pay_and_book: "Peye epi rezève",
  deposit_card_error: "Nou pa t ka pran depo ou. Tanpri tcheke kat ou epi eseye ankò.",
  deposit_unavailable: "Nou pa t ka chaje peman sekirize a. Tanpri rele klinik la.",
  deposit_needs_hold: "Nou pa t ka rezève lè sa a. Tanpri chwazi yon lè ankò.",
  deposit_processing:
    "Peman ou ap toujou konfime. Pa peye ankò — klinik la ap konfime randevou ou talè.",

  // Confirmation
  appointment_requested: "Nou resevwa demann randevou ou!",
  confirm_message:
    "Klinik la ap revize l epi voye yon konfimasyon ba ou. Si nou bezwen lòt enfòmasyon, ekip nou an ap kontakte w.",
  date: "Dat",
  time: "Lè",
  add_to_google: "Ajoute nan Google Calendar",
  download_ics: "Telechaje fichye kalandriye (.ics)",
  questions_call: "Kesyon? Rele nou nan",

  // Errors
  network_error: "Gen yon bagay ki pa mache. Tanpri eseye ankò.",

  // Common
  back: "Retounen",
  continue: "Kontinye",
  review: "Revize",

  // Step labels
  step_appointment: "Randevou",
  step_provider: "Doktè",
  step_time: "Lè",
  step_your_info: "Enfòmasyon ou",
  step_insurance: "Asirans",
} as const satisfies Record<keyof typeof en, string>;
